import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	projectsTabPanelInstruction: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.project-picker.projects-tab-panel-instruction',
		defaultMessage: 'Select the projects to associate with this priority scheme.',
		description: 'Modal description for the priority scheme details tab',
	},
	projectsTabPanelDescription: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.project-picker.projects-tab-panel-description',
		defaultMessage:
			'Associating projects with this new scheme will remove projects from their existing schemes. You may have to select new priorities for issues in these projects.',
		description: 'Modal description for the priority scheme details tab',
	},
});

export default messages;
